import { API_SERVICE } from "./root";
import { DialerServiceClient } from "@/pbjs/external/dialer/dialer_grpc_web_pb";

let dialerServiceClient: any = new DialerServiceClient(API_SERVICE, null, null);

export { dialerServiceClient };
